import { styled } from "@mui/material";

import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

export const Scrollbar = styled(SimpleBar)``;
